<form [formGroup]="formGroup">
  <div class="p-booking-info-mdl__section">
    <div class="p-booking-info-mdl__block">
      <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
        <h3 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.personalIinformation' | staticMsg"></h3>
      </div>

      <div class="p-booking-info-mdl__row" style="display: flex">
        <h4
          style="font-weight: normal"
          class="p-booking-info-mdl__heading-title"
          [innerHTML]="'label.aboutPassportName' | staticMsg"
        ></h4>
        <span class="c-text-with-tooltip__tooltip js-tooltip">
          <!-- ヘルプアイコン ※搭乗者姓名 -->
          <asw-tooltip
            iconImage='<img src="assets/images/icon_help_primary_20.svg" width="20" height="20" alt="help" />'
            [tooltipContent]="
              (isDomestic ? 'tooltip.aboutFullNameInput.domestic' : 'tooltip.aboutFullNameInput') | staticMsg
            "
            displayAreaClass="p-booking-info-mdl"
          ></asw-tooltip>
        </span>
      </div>
      <div class="p-booking-info-mdl__row p-booking-info-mdl__row--03 p-booking-info-mdl__row--mb16">
        <div *ngFor="let name of namesDisp; index as i" class="p-booking-info-mdl__row-item">
          <span class="u-visually-hidden" [innerHTML]="name.reader | staticMsg"></span>
          <asw-input
            id="{{ id }}-input-name-{{ i }}-{{ name.name }}"
            name="{{ id }}-input-name-{{ i }}-{{ name.name }}"
            [label]="name.label | staticMsg"
            [placeholder]="name.placeholder | staticMsg"
            [formControlName]="
              name.name === 'firstName' ? 'firstNameFc' : name.name === 'middleName' ? 'middleNameFc' : 'lastNameFc'
            "
            [required]="name.required"
            maxlength="{{ name.maxlength }}"
            [conversionType]="'paxName'"
          ></asw-input>
        </div>
      </div>
    </div>
    <div class="p-booking-info-mdl__block"></div>
    <!--区切り線-->
    <div class="p-booking-info-mdl__block p-booking-info-mdl__block--01" style="border-top: 0px">
      <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
        <h4 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.dateOfBirthForMandatory' | staticMsg"></h4>
        <span class="p-booking-info-mdl__heading-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
      </div>
      <div class="p-booking-info-mdl__row p-booking-info-mdl__row--mb16">
        <div class="p-booking-info-mdl__row-item">
          <asw-select-date-ymd
            #selectDateYmd
            id="{{ id }}-select-ymd-birthday"
            [order]="parts.selectDate.order"
            [dateFrom]="parts.selectDate.dateFrom"
            [dateTo]="parts.selectDate.dateTo"
            [initialDate]="parts.selectDate.initialDate"
            [altLabels]="['label.dateOfBirth.year', 'label.dateOfBirth.month', 'label.dateOfBirth.day']"
            [errorMessage]="errorMsg"
            (isError)="(isErrorDateYmd)"
            (selectedDateChange)="changeBirth($event)"
          ></asw-select-date-ymd>
        </div>
      </div>
      <div class="p-booking-info-mdl__row">
        <div class="p-booking-info-mdl__row-item">
          <asw-select
            id="{{ id }}-select-gender"
            name="{{ id }}-select-gender"
            label="{{ 'label.gender' | staticMsg }}"
            required
            [formControl]="genderFc"
            (change$)="update()"
          >
            <option value="">-</option>
            <option *ngFor="let item of parts.genderList" [value]="item.value">{{ item.disp }}</option>
          </asw-select>
        </div>
      </div>
    </div>
  </div>
</form>
